<!-- 新版轻骑兵首页 -->
<template>
  <div class="home">
    <!-- Header -->
    <Header @openForm="openForm" :isPageScroll="isPageScroll" :headColor="headColor" :router="'Product'"></Header>
    <!-- banner -->
    <div class="banner-bg">
      <div class="banner-box">
        <div class="banner-con">
          <div class="banner-title">轻骑兵<div style="font-size: 20px;vertical-align: super;line-height: 20px">®</div>融合集成平台</div>
          <div class="banner-desc">高效互通，无缝集成</div>
          <div class="banner-btn">
            <div class="banner-btn-appointment" @click="openForm">预约体验</div>
            <div class="banner-btn-expert" @click="openForm">联系行业专家</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底座 -->
    <div class="model-box">
      <div class="model-title">
        <div style="display: inline-flex">
          融合集成平台
        </div>
      </div>
      <div class="model-desc">统一、高效、低门槛的跨系统连接解决方案</div>
      <div class="model-con two-flex">
        <div class="two-flex-content">
          <img src="../assets/img/fusionIntegration/two-flex1.png">
          <p>打通业务边界</p>
          <div class="two-flex-desc">低成本适配新旧架构，实现跨系统业务协同，加速数据流动和汇聚，实现数据价值。</div>
        </div>
        <div class="two-flex-content">
          <img src="../assets/img/fusionIntegration/two-flex2.png">
          <p>服务重组与编排</p>
          <div class="two-flex-desc">通过可视化拖拽配置就可编排重组企业已有的服务资产，构建新API服务或集成方案。</div>
        </div>
        <div class="two-flex-content">
          <img src="../assets/img/fusionIntegration/two-flex3.png">
          <p>提升服务质量</p>
          <div class="two-flex-desc">提供服务运行深度监控，构建全面的集成监控和预警体系，快速定位问题。</div>
        </div>
        <div class="two-flex-content">
          <img src="../assets/img/fusionIntegration/two-flex4.png">
          <p>沉淀服务资产</p>
          <div class="two-flex-desc">形成统一标准的API/消息服务，并沉淀到资源市场中，供企业内外部开发人员使用。</div>
        </div>
      </div>
      <div class="more-btn" @click="openForm">预约体验</div>
    </div>
    <!-- 现实 -->
    <div class="model-box base-box">
      <div class="model-title">
        <div style="display: inline-flex">
          融合集成平台 助力企业实现信息流动与系统整合
        </div>
      </div>
      <div class="model-desc">轻松连接 高效互通 无缝集成</div>
      <div class="model-con base-con" style="text-align: center">
        <img class="model-con-img" src="../assets/img/fusionIntegration/base-con-img.svg">
      </div>
      <div class="more-btn" @click="openForm" style="position: relative;top: 10px">预约体验</div>
    </div>
    <!-- 主要功能 -->
    <div class="model-box function-box">
      <div class="model-title">主要功能</div>
      <div class="model-con function-con" style="width: 1230px;">
        <el-tabs ref="handoffTab" :tab-position="tabPosition" v-model="funActiveName">
          <el-tab-pane name="first">
            <div class="el-tab-paneBox" slot="label" name="first">
              <div class="el-tab-paneBoxIcon1"></div>接口快速开发
            </div>
            <div class="fun-tab-con">
              <div class="fun-tab-con-left">
                <div class="fun-tab-conTitle">接口快速开发</div>
                <div class="fun-tab-conDesc">将已有后端服务(API)通过在线可视化配置的方式注册到平台上，实现业务能力和数据的简单、快速、安全开放。</div>
              </div>
              <div class="fun-tab-conImg fun-tab-conImg1">
                <img src="../assets/img/fusionIntegration/function-box-img1.png" class="function-box-img"/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="接口编排开发" name="second">
            <div class="el-tab-paneBox" slot="label" name="second"><div class="el-tab-paneBoxIcon2"></div>接口编排开发</div>
            <div class="fun-tab-con">
              <div class="fun-tab-con-left">
                <div class="fun-tab-conTitle">接口编排开发</div>
                <div class="fun-tab-conDesc">通过图形化编排的方式组合已有API服务开放为新的APl，通过对API的多次组装形成组合应用，实现快速复制创新。</div>
              </div>
              <div class="fun-tab-conImg fun-tab-conImg2">
                <img src="../assets/img/fusionIntegration/function-box-img2.png" class="function-box-img"/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="数据集成" name="third">
            <div class="el-tab-paneBox el-tab-paneBoxPad" slot="label" name="third"><div class="el-tab-paneBoxIcon3"></div>数据集成</div>
            <div class="fun-tab-con">
              <div class="fun-tab-con-left">
                <div class="fun-tab-conTitle">数据集成</div>
                <div class="fun-tab-conDesc">支持MYSQL、达梦、Oracle、人大金仓等7种关系型数据库。</div>
              </div>
              <div class="fun-tab-conImg fun-tab-conImg3">
                <img src="../assets/img/fusionIntegration/function-box-img3.png" class="function-box-img"/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="消息集成" name="fourth">
            <div class="el-tab-paneBox el-tab-paneBoxPad" slot="label" name="fourth"><div class="el-tab-paneBoxIcon4"></div>消息集成</div>
            <div class="fun-tab-con">
              <div class="fun-tab-con-left">
                <div class="fun-tab-conTitle">消息集成</div>
                <div class="fun-tab-conDesc">支持Kafka、RabbitMQ、MQTT等 多种消息队列。</div>
              </div>
              <div class="fun-tab-conImg fun-tab-conImg4">
                <img src="../assets/img/fusionIntegration/function-box-img4.png" class="function-box-img"/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="接口运维管理" name="fifth">
            <div class="el-tab-paneBox el-tab-paneBoxPad" slot="label" name="fifth"><div class="el-tab-paneBoxIcon5"></div>接口运维管理</div>
            <div class="fun-tab-con">
              <div class="fun-tab-con-left">
                <div class="fun-tab-conTitle">接口运维管理</div>
                <div class="fun-tab-conDesc">记录应用接口发布日志、接口运行日志等，并对接口调用情况做出统计分析，方便企业API运维管理。</div>
              </div>
              <div class="fun-tab-conImg fun-tab-conImg5">
                <img src="../assets/img/fusionIntegration/function-box-img5.png" class="function-box-img"/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="资产市场" name="sixth">
            <div class="el-tab-paneBox el-tab-paneBoxPad" slot="label" name="sixth"><div class="el-tab-paneBoxIcon6"></div>资产市场</div>
            <div class="fun-tab-con">
              <div class="fun-tab-con-left">
                <div class="fun-tab-conTitle">资产市场</div>
                <div class="fun-tab-conDesc">企业开放接口/事件的汇聚之地，提供API检索、API文档及权限控制等功能，帮助企业管理开放能力。</div>
              </div>
              <div class="fun-tab-conImg fun-tab-conImg6">
                <img src="../assets/img/fusionIntegration/function-box-img6.png" class="function-box-img"/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="接口安全治理" name="seventh">
            <div class="el-tab-paneBox el-tab-paneBoxPad" slot="label" name="seventh"><div class="el-tab-paneBoxIcon7"></div>接口安全治理</div>
            <div class="fun-tab-con">
              <div class="fun-tab-con-left">
                <div class="fun-tab-conTitle">接口安全治理</div>
                <div class="fun-tab-conDesc">接口安全治理不仅提供全方位的网络安全防护，确保数据安全无忧，同时稳定保障系统运行，为业务稳健发展筑牢安全防线。</div>
              </div>
              <div class="fun-tab-conImg fun-tab-conImg7">
                <img src="../assets/img/fusionIntegration/function-box-img7.png" class="function-box-img"/>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="more-btn" @click="openForm">预约体验</div>
      </div>
    </div>
    <!-- 各类业务无缝集成 -->
    <div class="model-box value-box">
      <div class="model-title">各类业务无缝集成</div>
      <div class="model-con value-con clearfix">
        <ul>
          <li style="margin-right:25px;">
            <div class="value1">
              <p class="value-title">企业内部应用互联互通</p>
              <p class="value-desc">融合集成平台可构建统一的数据管理平台，将各个系统的数据进行整合和统一管理，支持数据分析和挖掘功能，帮助企业更好地利用数据资源，打破数据孤岛，实现数据的共享和流通。</p>
            </div>
          </li>
          <li>
            <div class="value2">
              <p class="value-title">企业内外部应用高效协同</p>
              <p class="value-desc">融合集成平台作为企业内部与外部之间进行高效、灵活协作的重要桥梁，可整合各个系统接口，提供统一、安全的输出接口，实现“对外能力开放，对内服务集成”。</p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 按钮 -->
      <div class="more-btn" @click="openForm">预约体验</div>
    </div>
    <ContactExperts></ContactExperts>
    <!-- footer -->
    <FhBottom/>
    <!-- 右侧联系方式 -->
    <SideBar @openForm="openForm"></SideBar>
    <!-- 表单 -->
    <HussarForm v-show="showForm" @closeForm="closeForm"></HussarForm>
    <!-- 返回顶部 -->
    <img src="../assets/img/homePage/top.png" class="back-top" @click="backTop" v-if="isPageScroll">
  </div>
</template>

<script>
import HussarForm from './include/HussarForm.vue';
import SideBar from './include/SideBar.vue';
import Header from './include/Header.vue';
import CaseSwiper from './CaseSwiper.vue';
import ContactExperts from './include/ContactExperts.vue';

const function21 = require('../assets/img/homePage/function21.gif');
const function22 = require('../assets/img/homePage/function22.gif');

export default {
  name: "FusionIntegration",
  data() {
    return {
      tabPosition:'top',
      headColor:"dark",
      isPageScroll: false,
      showForm: false,
      isSubmit: false,
      funActiveName: 'first',
      funcSrc: function21,
      caseBgIndex: 0,
      caseBgList: [
        {
          img: require("../assets/img/homePage/case4-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case5-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case6-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case1-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case2-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case3-bg.jpg"),
        },
      ]
    };
  },
  components: {
    ContactExperts,
    Header,
    HussarForm,
    SideBar,
    CaseSwiper,
  },
  watch: {
    funActiveName(n) {
      if (n === 'second') {
        this.funcSrc = function21;
        setTimeout(() => {
          this.funcSrc = function22;
        }, 2000);
      }
    }
  },
  methods: {
    // 跳转页面
    jumpTo(page) {
      const self = this;
      self.$router.push({ path: page });
    },
    changeBg(n) {
      const self = this;
      self.caseBgIndex = n;
    },
    openForm() {
      const self = this;
      self.showForm = true;
    },
    closeForm() {
      const self = this;
      self.showForm = false;
    },
    toLink() {
      window.open("http://www.jxdinfo.com");
    },
    // 返回顶部
    backTop() {
      $('html ,body').animate({scrollTop: 0}, 700);
    },
    // 页面滚动
    handleNavScroll() {
      const self = this;
      self.isPageScroll = false;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 80) {
        self.isPageScroll = true;
      }
    },
  },
  mounted() {
    // 视频播放
    var sUserAgent = navigator.userAgent;
    var phoneFlag = sUserAgent.indexOf('Android') > -1 || sUserAgent.indexOf('iPhone') > -1
      || sUserAgent.indexOf('iPad') > -1 || sUserAgent.indexOf('iPod') > -1 || sUserAgent.indexOf('Symbian') > -1;
    if(phoneFlag){
      document.getElementsByTagName('body')[0].classList.add('mobile')
      var oWidth = document.body.clientWidth || document.documentElement.clientWidth;
      document.getElementsByTagName("html")[0].style.fontSize = oWidth/750*100 + "px";
    }
    window.addEventListener('scroll', this.handleNavScroll);
    var ua = navigator.userAgent,
      isWindowsPhone = /(?:Windows Phone)/.test(ua),
      isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
      isAndroid = /(?:Android)/.test(ua),
      isFireFox = /(?:Firefox)/.test(ua),
      isChrome = /(?:Chrome|CriOS)/.test(ua),
      isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid &&       !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
      isPhone = /(?:iPhone)/.test(ua) && !isTablet,
      isPc = !isPhone && !isAndroid && !isSymbian;
    var os = {
      isTablet: isTablet,
      isPhone: isPhone,
      isAndroid: isAndroid,
      isPc: isPc
    };
    if (os.isAndroid || os.isPhone) {
      this.$router.replace({ path: '/apaasphone' });
    }
  },
  created() {},
};
</script>

<style scoped>
.home {color: #2E2E2E;}
.home >>> .header-con > div a{height: 100%;display: flex;align-items:center;color: #2e2e2e;}
.home >>> .navigator > div a:hover,.navigator .isActive {color: #186CF5;}
.more-btn {position: relative;left: 50%;transform: translateX(-50%);width: 120px;height: 42px;background: #186CF5;border-radius: 5px;font-size: 16px;text-align: center;color: #FFF;line-height: 42px;cursor: pointer;}
.more-btn:hover {background: rgba(21, 132, 243, 0.9);}
.value-btn {position: relative;left: 50%;transform: translateX(-50%);width: 110px;height: 38px;background: #FFF;border-radius: 5px;font-size: 16px;text-align: center;color: #186CF5;line-height: 38px;cursor: pointer;}
.value-btn:hover {background: rgba(255, 255, 255, 0.9);}

/* banner */
.banner-bg{background: linear-gradient(to right, #D5E2EF 0%, #D5E2EF 50%, #CFE1EF 50%, #CFE1EF 100%);}
.banner-box {width: 100%;height: 630px;background: url('../assets/img/fusionIntegration/banner-bg.png') no-repeat; background-size: 100% 100%;}
.banner-con {width: 1200px;margin: 0 auto;padding-top: 205px;}
.banner-title {font-size: 50px;font-weight: bold;line-height: 70px;display: flex}
.banner-desc {display: flex;align-items: center;position: relative;height: 40px;font-size: 28px;font-weight: 400;line-height: 40px;}
.banner-desc img {margin-left: 6px;z-index: 2;width: 45px}
.banner-desc img:hover {transform: scale(1.2);}
.banner-btn {position: relative;margin-top: 54px;cursor: pointer;}
.banner-btn-appointment {display: inline-block;width: 158px;height: 54px;background: linear-gradient(90deg, #018DFF 0%, #1A74F1 100%);border-radius: 5px;color: #FFF;font-size: 18px;text-align: center;line-height: 54px;}
.banner-btn-appointment:hover {background: linear-gradient(90deg, #186CF5 0%, #095EE9 100%);}
.banner-btn-expert {display: inline-block;width: 158px;height: 54px;margin-left: 13px;border: 1px solid #1D79FB;border-radius: 5px;line-height: 54px;color: #1D79FB;font-size: 18px;text-align: center;}
.banner-btn-expert:hover {background: rgba(29, 121, 251, 0.1);}

/*更敏捷*/
.two-flex{display: flex;}
.two-flex .two-flex-content{padding:0px 20px;margin:60px 5px;width: 305px;height: 354px;background: linear-gradient( 44deg, #FFFFFF 0%, #F5F9FF 100%);border-radius: 2px 2px 2px 2px;border: 1px solid #EBF3FF; }
.two-flex .two-flex-content:hover{border: 1px solid #3581F3;}
.two-flex-content p{text-align: center;font-size: 20px;line-height: 31px;font-weight: bold;margin-top: 30px}
.two-flex-content .two-flex-desc{font-size: 14px;color: #2e2e2e;line-height: 31px;text-align: justify;margin-top: 15px}
.two-flex-content img{height: 134px;margin: auto;position: relative;top: 20px;left: 24px}

/*现实*/
.base-box{background: url("../assets/img/fusionIntegration/base-con-img-bg.png") no-repeat;background-size: 100% 100%}
.model-box {position: relative;width: 100%;padding: 80px 0 100px 0;}
.model-con {width: 1200px;margin: 0 auto;position: relative;}
.model-con-img {width: 1200px;height: 636px;margin: 50px auto}
.model-title {font-size: 34px;font-weight: bold;text-align: center;line-height: 52px;}
.model-desc {font-size: 22px;text-align: center;line-height: 60px;height: 43px;}

/* 主要功能 */
.function-box {height: 1000px;}
.function-con {height: 653px;padding-top: 12px;}
.fun-tab-con {width: 1200px;height: 600px;border-radius: 4px 4px 4px 4px;opacity: 1;padding: 60px 20px 40px 40px;display: flex}
.function-con >>> .el-tabs__content {height: calc(100% - 126px);}
.function-con >>> .el-tabs__header {margin-bottom: 38px;margin-right: unset!important;margin-top: 50px;}
.function-con >>> .el-tabs__nav-wrap{border-bottom: 1px solid #DFE0E2;padding: 0px 20px;margin: 0px 20px;}
.function-con >>> .el-tabs__nav-wrap::after {display: none;}
.function-con >>> .el-tabs__active-bar {display: none;}
.function-con >>> .el-tabs__nav {width: 100%;text-align: center;}
.function-con >>> .el-tabs__item {width: 168px;height: 120px;padding: 0;line-height: 40px;text-align: center;font-size: 18px;color: #333;}
.el-tab-paneBox {align-items: center;height: 100%;width: 100%;position: relative;}
.el-tab-paneBoxPad {padding-right: 20px;}
.el-tab-paneBoxIcon1 {width: 75px;height: 75px;background: url("../assets/img/fusionIntegration/function-box-icon1.png") no-repeat;background-size: 100% 100%;margin: auto;margin-top: -10px}
.el-tab-paneBoxIcon2 {width: 65px;height: 65px;background: url("../assets/img/fusionIntegration/function-box-icon2.png") no-repeat;background-size: 100% 100%;margin: auto;}
.el-tab-paneBoxIcon3 {width: 65px;height: 65px;background: url("../assets/img/fusionIntegration/function-box-icon3.png") no-repeat;background-size: 100% 100%;margin: auto;}
.el-tab-paneBoxIcon4 {width: 65px;height: 65px;background: url("../assets/img/fusionIntegration/function-box-icon4.png") no-repeat;background-size: 100% 100%;margin: auto;}
.el-tab-paneBoxIcon5 {width: 65px;height: 65px;background: url("../assets/img/fusionIntegration/function-box-icon5.png") no-repeat;background-size: 100% 100%;margin: auto;}
.el-tab-paneBoxIcon6 {width: 65px;height: 65px;background: url("../assets/img/fusionIntegration/function-box-icon6.png") no-repeat;background-size: 100% 100%;margin: auto;}
.el-tab-paneBoxIcon7 {width: 65px;height: 65px;background: url("../assets/img/fusionIntegration/function-box-icon7.png") no-repeat;background-size: 100% 100%;margin: auto;}
.el-tab-pane{background:url("../assets/img/fusionIntegration/el-tab-pane-bg.png") no-repeat;background-size: 100% 100%}
.function-con >>> #tab-0 {margin-top: 0;}
.function-con >>> #tab-first {margin-top: 0;}
.function-con >>> .el-tabs__item.is-active {border-bottom: 3px solid #287FFB;color: #2e2e2e}
.function-con >>> .fun-tab-con-left {width: 380px;}
.function-con >>> .fun-tab-con-left img{position: relative;top: -192px}
.function-con >>> .fun-tab-conTitle {width: 200px;height: 80px;font-size: 24px;color: #3B77F3;font-weight: bold;padding-left: 5px}
.function-con >>> .fun-tab-conDesc {width: 325px;height: 190px;font-size: 16px;color: #2e2e2e;line-height: 33px;text-align: justify;padding-left: 5px}
.function-con >>> .fun-tab-conImg {width: 875px;height: 522px;}
.fun-tab-conImg img{box-shadow: 0px 0px 10px 1px rgba(10,63,190,0.17);}
.fun-tab-conImg .function-box-img{width: 100%;box-shadow: 0px 0px 10px 1px rgba(10,63,190,0.17);}
.home .el-tabs--left .el-tabs__header.is-left {margin-right: 0;}
.tab-left {width: 366px;float: left;position: relative;padding-right: 44px;}
.left-title {margin: 12px 0 58px;font-size: 28px;font-weight: bold;color: #333;line-height: 40px;}
.tab-left ul {font-size: 14px;line-height: 31px;}
.tab-left ul li span {display: block;float: left;width: calc(100% - 24px);}
.tab-left ul li span.fun-li-circle {display: block;width: 14px;height: 14px;margin-right: 10px;position: relative;top: 9px;background: linear-gradient(180deg, #2377FF 0%, #BDD6FF 100%);border-radius: 50%;}
.tab-right {width: calc(100% - 366px);float: left;text-align: center;}
.tab-right img.boxshadow {box-shadow: 0 3px 10px 1px rgba(0, 0, 0, .16);}
.function-box .more-btn {position: relative;left: 110px;top:-135px;}

/* 快速构建轻应用 */
.value-box {height: 620px;}
.value-con {padding-top: 60px;padding-bottom:35px;font-size: 16px;color: #2E2E2E;line-height: 31px;}
.value-con ul li {width: 586px;height: 225px;float: left;margin-bottom: 25px;border-radius: 5px;background:#F7FAFD;color: #2e2e2e;padding: 30px 20px 5px 30px}
.value-con ul li div{float: left;height: 100%;}
.value-con ul li div:nth-child(2){width: 84%;background: #2D6EEB;border-radius: 5px;padding: 20px 5px 10px 20px}
.value-con ul li:nth-child(3n) {margin-right: 0;}
.value-con ul li p.value-title {font-size: 20px;font-weight: bold;margin-bottom: 10px}
.value-con ul li p.value-desc {font-size: 16px;}
.value-box .value1{background: url("../assets/img/fusionIntegration/value-box-white1.png") no-repeat;background-position: right bottom;}
.value-box .value2{background: url("../assets/img/fusionIntegration/value-box-white2.png") no-repeat;background-position: right bottom;}
.value-con ul li:hover{background: #115CE0;color: #fff}

/* 案例 */
.case-box {height: 800px;transition: background 1s ease;background-repeat: no-repeat !important; background-size: cover !important;}
.case-box .model-title, .case-box .model-desc {color: #FFF;}
.case-con {display: flex;margin-top: 54px;margin-bottom: 40px;}
.case-industry {background: url('../assets/img/homePage/case-industry-bg.png');width: 275px;height: 428px;padding: 16px 39px 0 32px;color: #FFF;}
.case-industry-title {font-size: 20px;font-weight: bold;line-height: 52px;border-bottom: 1px solid #FFF;}
.case-industry ul li {float: left;margin-top: 32px;width: 64px;margin-right: 56px;font-size: 16px;}
.case-industry ul li:nth-child(2n) {margin-right: 0;}
.case-more-btn {background: linear-gradient(90deg, #1A74F1 0%, #018DFF  100%);position: relative;left: 50%;transform: translateX(-50%);width: 105px;height: 44px;border-radius: 5px;font-size: 14px;text-align: center;color: #FFF;line-height: 44px;cursor: pointer;}
.case-more-btn img {margin-left: 3px;transition: all .3s ease;}
.case-more-btn:hover img {transform: translateX(8px);}

/* 返回顶部 */
.back-top {position: fixed;top: calc(40% + 250px);right: 5px;cursor: pointer;}
/*取消页面光标*/
.model-box div,img{caret-color: transparent;}
</style>



// WEBPACK FOOTER //
// src/components/FusionIntegration.vue